import React from "react";
import { Grid2 } from "@mui/material";
import YouTube from "react-youtube";
import PageTitle from "../../../components/Common/PageTitle/index";
import ContentCard from "../../../components/Content/ContentCard/index";
import LinkBox from "../../../components/Content/LinkBox";
import { Gapper } from "../../../components/ui/Gapper";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SECTION_TITLE,
  FOOTER_TEXT,
  LINK_BOX_TITLE,
  LINK_BOX_URL,
  YOUTUBE_VIDEO_ID,
  YOUTUBE_OPTS,
  HAPPINESS_DATA,
} from "./Happiness.constants";
import {
  RootBox,
  YouTubeWrapper,
  SectionTitleTypography,
} from "./Happiness.styles";
import { FooterText } from "../../../components/Common/FooterText";

const Happiness = () => {
  return (
    <RootBox>
      <Grid2 container spacing={2} sx={{ mb: 4 }}>
        <PageTitle
          title={PAGE_TITLE}
          text={PAGE_TEXT}
          noIcon
          videoUrl={VIDEO_URL}
        />
        <YouTubeWrapper>
          <YouTube videoId={YOUTUBE_VIDEO_ID} opts={YOUTUBE_OPTS} />
        </YouTubeWrapper>
      </Grid2>

      <Gapper gap={20}>
        <SectionTitleTypography>{SECTION_TITLE}</SectionTitleTypography>

        <Grid2 container spacing={2}>
          {HAPPINESS_DATA.map((item) => (
            <Grid2 item key={item.id} size={{ xs: 12, md: 6 }}>
              <ContentCard item={item} height="150px" />
            </Grid2>
          ))}
        </Grid2>
      </Gapper>

      <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_URL} />
      <FooterText>{FOOTER_TEXT}</FooterText>
    </RootBox>
  );
};

export default Happiness;
